import { Col, Row, Image, Typography, Card, Skeleton, Button } from 'antd'
import React, { useCallback, useEffect } from 'react'
import styles from './AuthorDetails.module.css'
import { useBeforeUnload, useNavigate, useNavigationType } from 'react-router-dom';
import ArrowBack from '../../Icons/arrow-back.png'
import { useDispatch } from 'react-redux';
import { removeLastWindowNHQ } from '../../Slices/WindowNHQSlice';
import { AnyNaptrRecord } from 'dns';
import PageBackButton from '../PageBackButton/PageBackButton';

const {Title, Paragraph, Text} = Typography;

function parseHTML(html: string): string {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || '';
}

type Props = {
  details:any,
  loading?:any,
}

const AuthorDetails = (props: Props) => {
  const {details, loading} = props;
  const navigate = useNavigate();
  const dispatch:any = useDispatch();

  const handleBack =()=> {
      navigate(-1);
      // dispatch(removeLastWindowNHQ());
  }

  return (

    <Skeleton loading={loading} avatar> 
    <Row align={'middle'}>
        <Col xs={7} sm={4} md={6} lg={4} xxl={3}>
        <Image preview={false} className={styles.authorProfileImg} width={100} height={100}
                src={details?.pic} />
        </Col>
        <PageBackButton onClick={handleBack}/>
        <Col style={{padding: "0 20px"}} xs={17} sm={20}  md={18} lg={20} xxl={21}>
        <Title className={styles.authorName} level={2}>{details?.name}</Title>
        <Text style={{fontWeight: "500"}} className={styles.authorStats}>{`@${details?.username}`}</Text>
        <Paragraph ellipsis={{symbol: "Read more", rows: 2, expandable: true, }} className={styles.authorBio}>{parseHTML(details?.description)}</Paragraph>
        </Col>
    </Row>
    </Skeleton>
  )
}

export default AuthorDetails